import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly showSuccess = signal(false);
  readonly showError = signal(false);
  readonly successMessage = signal('Operazione completa con successo!');
  readonly errorMessage = signal("Errore durante l'operazione, riprova!");

  private successTimer: ReturnType<typeof setTimeout> | null = null;
  private errorTimer: ReturnType<typeof setTimeout> | null = null;

  success(message = 'Operazione completa con successo!'): void {
    if (this.successTimer) clearTimeout(this.successTimer);
    this.successMessage.set(message);
    this.showSuccess.set(true);
    this.successTimer = setTimeout(() => this.showSuccess.set(false), 4000);
  }

  error(message = "Errore durante l'operazione, riprova!"): void {
    if (this.errorTimer) clearTimeout(this.errorTimer);
    this.errorMessage.set(message);
    this.showError.set(true);
    this.errorTimer = setTimeout(() => this.showError.set(false), 4000);
  }
}
